import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';

const MOCK_ACCOUNTS = [
  { name: 'Luis Pernalete', email: 'luispernalete1188@gmail.com', picture: 'https://api.dicebear.com/7.x/avataaars/svg?seed=luis' },
  { name: 'Gaby Admin', email: 'gaby@conexopos.com', picture: 'https://api.dicebear.com/7.x/avataaars/svg?seed=gaby' },
];

export default function MockGoogleLogin() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo') || '/menu';

  const selectAccount = (email) => {
    const mockSessionId = `mock_google_${email}`;
    navigate(`/auth/callback?session_id=${mockSessionId}&returnTo=${encodeURIComponent(returnTo)}`);
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4 font-sans selection:bg-yellow-500/30">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-[450px] w-full bg-[#0a0a0a] rounded-[40px] border border-white/5 p-10 md:p-12 shadow-2xl relative overflow-hidden"
      >
        {/* Decorative background flare */}
        <div className="absolute -top-24 -right-24 w-48 h-48 bg-yellow-500/10 blur-[80px] rounded-full" />
        <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-yellow-500/5 blur-[80px] rounded-full" />

        {/* Conexo Logo Branding */}
        <div className="flex flex-col items-center mb-10">
          <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-orange-600 rounded-2xl flex items-center justify-center shadow-lg shadow-yellow-500/20 mb-6">
            <span className="text-black font-black text-3xl italic">C</span>
          </div>
          <h1 className="text-3xl font-black text-white tracking-tighter uppercase mb-2">Conexo <span className="text-yellow-500">POS</span></h1>
          <p className="text-gray-500 text-sm font-medium tracking-widest uppercase">Universal Identity Bridge</p>
        </div>

        <div className="text-center mb-10">
          <h2 className="text-xl font-bold text-white mb-2">Elige tu cuenta</h2>
          <p className="text-gray-500 text-sm">Inicia sesión de forma segura para continuar</p>
        </div>

        {/* Account List */}
        <div className="space-y-3">
          {MOCK_ACCOUNTS.map((acc) => (
            <motion.button
              key={acc.email}
              whileHover={{ scale: 1.02, backgroundColor: 'rgba(255,255,255,0.03)' }}
              whileTap={{ scale: 0.98 }}
              onClick={() => selectAccount(acc.email)}
              className="w-full flex items-center p-4 rounded-3xl border border-white/5 bg-white/[0.01] transition-all hover:border-yellow-500/30 group"
            >
              <div className="relative">
                <img src={acc.picture} alt="" className="w-12 h-12 rounded-2xl mr-4 bg-gray-900 border border-white/10" />
                <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 border-2 border-[#0a0a0a] rounded-full" />
              </div>
              <div className="text-left flex-1">
                <p className="text-sm font-bold text-white group-hover:text-yellow-500 transition-colors">{acc.name}</p>
                <p className="text-xs text-gray-500">{acc.email}</p>
              </div>
              <div className="opacity-0 group-hover:opacity-100 transition-opacity">
                <svg className="w-5 h-5 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </motion.button>
          ))}
          
          <button className="w-full flex items-center p-4 rounded-3xl border border-dashed border-white/10 hover:border-white/20 transition-all text-left group">
            <div className="w-12 h-12 rounded-2xl bg-white/[0.02] flex items-center justify-center mr-4 border border-white/5 group-hover:bg-white/[0.05]">
              <svg className="w-5 h-5 text-gray-500 group-hover:text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
            </div>
            <p className="text-sm font-bold text-gray-400 group-hover:text-white">Añadir otra cuenta</p>
          </button>
        </div>

        <div className="mt-12 text-[10px] text-gray-600 text-center leading-relaxed font-medium uppercase tracking-widest">
          Protección de identidad garantizada por <span className="text-yellow-500/50">Conexo Secure Bridge</span>
        </div>
      </motion.div>
    </div>
  );
}
